// import React from "react";
// import {useTheme} from "@mui/material/styles";
// import {CircularProgress} from "@mui/material";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import Paper from "@mui/material/Paper";
// import MenuItem from "@mui/material/MenuItem";
// import TextField from "@mui/material/TextField";
// import InputLabel from "@mui/material/InputLabel";
// import FormGroup from "@mui/material/FormGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import FormControl from "@mui/material/FormControl";
// import Switch from "@mui/material/Switch";
// import Select from "@mui/material/Select";
// import InfoIcon from "@mui/icons-material/Info";
// import IconButton from "@mui/material/IconButton";
// import Tooltip from "@mui/material/Tooltip";
// import Grid from "@mui/material/Grid";
// import Typography from "@mui/material/Typography";
// import {useTranslation} from "react-i18next";
// import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
// import DatasetColumnEditor from "./DatasetColumnEditor";

// export default function DatasetConfigurator(props) {
//     const theme = useTheme();
//     // init internationalization
//     const {t} = useTranslation();

//     const [CSVEncoding] = React.useState("UTF-8");
//     const [uploadClicked, setUploadClicked] = React.useState(false);

//     const handleDatasetNameChange = (
//         event: React.ChangeEvent<HTMLInputElement>
//     ) => {
//         props.setDatasetName(event.target.value);
//     };

//     const handleButtonClick = (event) => {
//         // simple method to set variable to true after button click to display Spinner
//         setUploadClicked(true);
//         // then call actual next handling method
//         props.handleNext(event);
//     }

//     return (
//         <Grid
//             id="dataset-configurator-container"
//             container
//             spacing={2}
//             sx={{padding: theme.spacing(8, 1)}}
//         >
//             <Grid
//                 item
//                 xs={5}
//                 sx={{
//                     "& .MuiSelect-select": {minWidth: 100},
//                     "& .MuiFormControlLabel-root": {width: "auto"},
//                 }}
//             >
//                 <FormControl>
//                     <TextField
//                         id="filled-basic"
//                         label={t("datasetConfigurator.DatasetNameFillable")}
//                         defaultValue={props.datasetName}
//                         error={Boolean(props.errors.datasetName)}
//                         onChange={handleDatasetNameChange}
//                         variant="filled"
//                     />
//                 </FormControl>
//                 <Tooltip title={t("datasetConfigurator.HintDatasetName")}>
//                     <IconButton>
//                         <InfoIcon/>
//                     </IconButton>
//                 </Tooltip>
//                 <br/>
//                 <Typography variant="h6">
//                     <br/>
//                     {t("datasetConfigurator.FileSettingsTitle")}
//                 </Typography>
//                 <br/>
//                 <FormControl variant="filled" disabled>
//                     <InputLabel>
//                         {t("datasetConfigurator.CSVEncodingDropdown")}
//                     </InputLabel>
//                     <Select value={CSVEncoding}>
//                         <MenuItem value="UTF-8">UTF-8</MenuItem>
//                         <MenuItem value="ISO 8859-1 ">ISO 8859-1</MenuItem>
//                     </Select>
//                 </FormControl>
//                 <Tooltip title={t("datasetConfigurator.HintEncoding")}>
//                     <IconButton>
//                         <InfoIcon/>
//                     </IconButton>
//                 </Tooltip>
//                 <FormControl variant="filled" disabled>
//                     <InputLabel>
//                         {t("datasetConfigurator.CSVDelimiterDropdown")}
//                     </InputLabel>
//                     <Select value={props.CSVMeta.delimiter}>
//                         <MenuItem value=",">,</MenuItem>
//                         <MenuItem value=";">;</MenuItem>
//                     </Select>
//                 </FormControl>
//                 <Tooltip title={t("datasetConfigurator.HintDelimiter")}>
//                     <IconButton>
//                         <InfoIcon/>
//                     </IconButton>
//                 </Tooltip>
//                 <Typography variant="h6">
//                     <br/>
//                     {t("datasetConfigurator.DatasetSettingsTitle")}
//                     <Tooltip title={t("datasetConfigurator.HintDatasetSettings")}>
//                         <IconButton>
//                             <InfoIcon/>
//                         </IconButton>
//                     </Tooltip>
//                 </Typography>
//                 <br/>
//                 <FormGroup>
//                     <FormControlLabel
//                         control={<Switch disabled/>}
//                         label={t("datasetConfigurator.UseCustomVal")}
//                     />
//                     <FormControlLabel
//                         disabled
//                         control={<Switch disabled/>}
//                         label={t("datasetConfigurator.UseTest")}
//                     />
//                 </FormGroup>
//                 <br/>
//             </Grid>
//             <Grid item xs={6}>
//                 <Typography variant="h6">
//                     {t("datasetConfigurator.TablePreviewTitle")}
//                 </Typography>
//                 <br/>
//                 <TableContainer component={Paper} sx={{maxWidth: "50vw"}}>
//                     <Table size="small">
//                         <caption>
//                             {t("datasetConfigurator.TableDescription1")} ({" "}
//                             {props.CSVMeta.fields.length}{" "}
//                             {t("datasetConfigurator.TableDescription2")}x{" "}
//                             {props.parsedCSV.length}{" "}
//                             {t("datasetConfigurator.TableDescription3")})
//                         </caption>
//                         <TableHead>
//                             <TableRow>
//                                 {Object.keys(props.parsedCSV[0]).map((column, index) => (
//                                     <TableCell key={`col-${index}`}>{column}</TableCell>
//                                 ))}
//                             </TableRow>
//                         </TableHead>
//                         <TableBody>
//                             {/* display first 5 rows */}
//                             {props.parsedCSV.slice(0, 5).map((row, indexRow) => (
//                                 <TableRow key={indexRow}>
//                                     {Object.keys(props.parsedCSV[0]).map((column, indexCol) => (
//                                         <TableCell key={`row-${indexRow}-${indexCol}`}>
//                                             {row[column]}
//                                         </TableCell>
//                                     ))}
//                                 </TableRow>
//                             ))}
//                         </TableBody>
//                     </Table>
//                 </TableContainer>
//             </Grid>

//             {props.showEditor && <DatasetColumnEditor columnNamesTooLong={props.columnNamesTooLong}
//                                                       handleTablePreviewRefresh={props.handleTablePreviewRefresh}/>}
//             {!uploadClicked ? (
//                 <Box sx={{display: "flex", flexDirection: "row", pt: 2, width: "100%"}}>
//                     <Button
//                         color="inherit"
//                         disabled={props.activeStep === 0}
//                         onClick={props.handleBack}
//                         sx={{mr: 1}}
//                     >
//                         {t("datasetCreator.BackButton")}
//                     </Button>
//                     <Box sx={{flex: "1 1 auto"}}/>
//                     <Button onClick={handleButtonClick}>
//                         {t("datasetCreator.StartCreationButton")}
//                     </Button>
//                 </Box>
//             ) : (
//                  <Box sx={{display: "flex", flexDirection: "row", pt: 2, width: "100%"}}>
//                     <CircularProgress/>
//                     <p>&nbsp;{t("datasetCreator.DatasetCreationInProgress")}</p>
//                 </Box>
//             )}
//         </Grid>
//     );
// }

import React from "react";
import { useTheme } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Switch from "@mui/material/Switch";
import Select from "@mui/material/Select";
import InfoIcon from "@mui/icons-material/Info";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import DatasetColumnEditor from "./DatasetColumnEditor";

export default function DatasetConfigurator(props) {
  const theme = useTheme();
  const { t } = useTranslation();

  const [CSVEncoding] = React.useState("UTF-8");
  const [uploadClicked, setUploadClicked] = React.useState(false);

  const handleDatasetNameChange = (event) => {
    props.setDatasetName(event.target.value);
  };

  const handleButtonClick = (event) => {
    setUploadClicked(true);
    props.handleNext(event);
  };

  return (
    <Box
      sx={{ p: { xs: 1, md: 5 }, background: theme.palette.background.default }}
    >
      <Grid
        container
        spacing={3}
        justifyContent="center"
        alignItems="flex-start"
        sx={{
          maxWidth: 1200,
          margin: "0 auto",
        }}
      >
        {/* Form and settings */}
        <Grid item xs={12} md={5}>
          <Card sx={{ borderRadius: 3, boxShadow: 4, p: { xs: 2, md: 3 } }}>
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Typography variant="h6" fontWeight={600}>
                  {t("datasetConfigurator.DatasetNameFillable")}
                </Typography>
                <Tooltip title={t("datasetConfigurator.HintDatasetName")}>
                  <IconButton size="small" sx={{ ml: 1 }}>
                    <InfoIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
              <TextField
                id="filled-basic"
                fullWidth
                label={t("datasetConfigurator.DatasetNameFillable")}
                defaultValue={props.datasetName}
                error={Boolean(props.errors.datasetName)}
                onChange={handleDatasetNameChange}
                variant="filled"
                size="small"
                sx={{ mb: 3 }}
              />

              <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 2 }}>
                {t("datasetConfigurator.FileSettingsTitle")}
              </Typography>
              <Box sx={{ mb: 2 }}>
                <FormControl fullWidth variant="filled" disabled sx={{ my: 1 }}>
                  <InputLabel>
                    {t("datasetConfigurator.CSVEncodingDropdown")}
                  </InputLabel>
                  <Select value={CSVEncoding}>
                    <MenuItem value="UTF-8">UTF-8</MenuItem>
                    <MenuItem value="ISO 8859-1 ">ISO 8859-1</MenuItem>
                  </Select>
                </FormControl>
                <Tooltip title={t("datasetConfigurator.HintEncoding")}>
                  <IconButton size="small" sx={{ ml: 1 }}>
                    <InfoIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box sx={{ mb: 2 }}>
                <FormControl fullWidth variant="filled" disabled sx={{ my: 1 }}>
                  <InputLabel>
                    {t("datasetConfigurator.CSVDelimiterDropdown")}
                  </InputLabel>
                  <Select value={props.CSVMeta.delimiter}>
                    <MenuItem value=",">,</MenuItem>
                    <MenuItem value=";">;</MenuItem>
                  </Select>
                </FormControl>
                <Tooltip title={t("datasetConfigurator.HintDelimiter")}>
                  <IconButton size="small" sx={{ ml: 1 }}>
                    <InfoIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>

              <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 2 }}>
                {t("datasetConfigurator.DatasetSettingsTitle")}
                <Tooltip title={t("datasetConfigurator.HintDatasetSettings")}>
                  <IconButton size="small" sx={{ ml: 1 }}>
                    <InfoIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Typography>
              <FormGroup sx={{ mt: 1 }}>
                <FormControlLabel
                  control={<Switch disabled />}
                  label={t("datasetConfigurator.UseCustomVal")}
                />
                <FormControlLabel
                  disabled
                  control={<Switch disabled />}
                  label={t("datasetConfigurator.UseTest")}
                />
              </FormGroup>
            </CardContent>
          </Card>
        </Grid>

        {/* Table Preview */}
        <Grid item xs={12} md={7}>
          <Card sx={{ borderRadius: 3, boxShadow: 4, p: { xs: 1, md: 3 } }}>
            <CardContent>
              <Typography variant="h6" fontWeight={600}>
                {t("datasetConfigurator.TablePreviewTitle")}
              </Typography>
              <TableContainer
                component={Paper}
                sx={{
                  mt: 2,
                  width: "100%",
                  maxWidth: { xs: "100%", md: "100%" },
                  overflowX: "auto",
                  background: theme.palette.background.paper,
                  borderRadius: 2,
                }}
              >
                {props.parsedCSV.length && props.CSVMeta.fields.length ? (
                  <Table size="small" aria-label="CSV preview">
                    <caption
                      style={{
                        background: theme.palette.grey[100],
                        padding: 6,
                      }}
                    >
                      {t("datasetConfigurator.TableDescription1")} (
                      {props.CSVMeta.fields.length}{" "}
                      {t("datasetConfigurator.TableDescription2")} x{" "}
                      {props.parsedCSV.length}{" "}
                      {t("datasetConfigurator.TableDescription3")})
                    </caption>
                    <TableHead>
                      <TableRow>
                        {Object.keys(props.parsedCSV[0] || {}).map(
                          (column, index) => (
                            <TableCell
                              key={`col-${index}`}
                              sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                            >
                              {column}
                            </TableCell>
                          )
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {props.parsedCSV.slice(0, 5).map((row, indexRow) => (
                        <TableRow key={indexRow}>
                          {Object.keys(props.parsedCSV[0] || {}).map(
                            (column, indexCol) => (
                              <TableCell
                                key={`row-${indexRow}-${indexCol}`}
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                {row[column]}
                              </TableCell>
                            )
                          )}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ m: 3 }}
                  >
                    {t("datasetConfigurator.NoData")}
                  </Typography>
                )}
              </TableContainer>
            </CardContent>
          </Card>
        </Grid>

        {/* (Optional) Column Editor */}
        {props.showEditor && (
          <Grid item xs={12} md={7}>
            <DatasetColumnEditor
              columnNamesTooLong={props.columnNamesTooLong}
              handleTablePreviewRefresh={props.handleTablePreviewRefresh}
            />
          </Grid>
        )}

        {/* Action Bar */}
        <Grid item xs={12}>
          {!uploadClicked ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "flex-end",
                alignItems: { xs: "stretch", sm: "center" },
                pt: 2,
                gap: 2,
              }}
            >
              <Button
                variant="outlined"
                color="inherit"
                disabled={props.activeStep === 0}
                onClick={props.handleBack}
                sx={{
                  fontWeight: 600,
                  width: { xs: "100%", sm: "auto" },
                }}
              >
                {t("datasetCreator.BackButton")}
              </Button>
              <Button
                onClick={handleButtonClick}
                variant="contained"
                color="primary"
                sx={{
                  fontWeight: 600,
                  width: { xs: "100%", sm: "auto" },
                }}
              >
                {t("datasetCreator.StartCreationButton")}
              </Button>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                pt: 2,
                gap: 2,
              }}
            >
              <CircularProgress />
              <Typography variant="body2">
                {t("datasetCreator.DatasetCreationInProgress")}
              </Typography>
            </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
